<template>
    <div v-if="fees_type!=null">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-row>
                <v-col cols="3">
                    <v-text-field rounded outlined label="Receipt No" placeholder="Enter valid receipt no" v-model="receipt_no" dense></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-combobox rounded outlined dense required :items="fees_type" item-text="name" v-model="fee_type" label="Fee Type" outlined />
                </v-col>
                <v-col cols="3">
                    <v-combobox rounded outlined dense required :items="ay_list" item-text="ay" v-model="curr_ay" label="Academic Year" outlined />
                </v-col>
                <v-col cols="3">
                    <v-btn class="button mt-0" @click="getReceipt">Get Receipt</v-btn>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
     import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            fees_type: null,
            fee_type: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_list: null,
            curr_ay: null,
            receipt_no: null,
        }),
        methods: {
            getReceipt() {
                const formData = {
                    fee_type: this.fee_type,
                    curr_ay: this.curr_ay,
                    receipt_no: this.receipt_no,
                };
                axios
                    .post("/feesPayment/getReceiptId", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.receipt_id == null) {
                                this.showSnackbar("#b71c1c", "Receipt not Found!!!");
                                return;
                            } else {
                                if (this.fee_type == "Admission Form") {
                                    this.$store.commit("setform_fees_trans_id", res.data.receipt_id);
                                    this.$router.push({ name: "form-fees-receipt" });
                                    return;
                                } else {
                                    this.$store.commit("setreceipt_id", res.data.receipt_id);
                                    if (this.fee_type == "Admission Fees") {
                                        this.$router.push({ name: "admission-fees-receipt" });
                                        return;
                                    }
                                    ////other code need to be written
                                }
                            }
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            axios
                .post("/feesPayment/receipt")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.fees_type = res.data.fees_type;
                        this.ay_list = res.data.ay_list;
                        this.curr_ay = res.data.curr_ay;
                        this.fee_type = this.fees_type[0];
                    } else {
                        //error
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                });
        },
    };
</script>
